export const maskingString = ({
  str,
  visibleChars = 4,
  separator = ' ',
  replacer = '*',
}: {
  str: string
  visibleChars?: number
  separator?: string
  replacer?: string
}): string => {
  const maskedCharacters = str.slice(0, -visibleChars).replace(/[a-zA-Z0-9]/g, replacer)
  const lastCharacters = str.slice(-visibleChars)

  return `${maskedCharacters}${separator}${lastCharacters}`
}
